import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import debounce from "lodash.debounce";

import WP from "WP";
import api from "api";
import modules from "modules";
import { setImageGallery, setCurrentView } from "store";

import RelatedEvents from "./RelatedEvents";
import RegistrationForm from "./RegistrationForm";
import EventInfo from "./EventInfo";
import Container from "partials/Container";
import GridElement from "partials/GridElement";
import Overlay from "partials/Overlay";
import ErrorBoundary from "partials/ErrorBoundary";
import Footer from "partials/Footer";
import CookieNotice from "partials/CookieNotice";

import Media, { ScreenWidth } from "css/Media";
import theme from "css/theme";

export class SingleEventPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
      related_events: [],
      loading: true,
    };
  }

  componentWillMount() {
    this.checkScreenSize();
  }

  componentDidMount() {
    this.props.setCurrentView(null);
    document.addEventListener(
      "resize",
      debounce(() => this.checkScreenSize()),
      500
    );
    this.preparePage();
  }

  componentWillUnmount() {
    document.removeEventListener("resize", this.checkScreenSize);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.slug !== this.props.match.params.slug) {
      this.preparePage();
    }
  }

  checkScreenSize() {
    let isMobile = false;
    if (ScreenWidth.lessThan("s")) {
      isMobile = true;
    }

    this.setState({ isMobile: isMobile });
  }

  preparePage = () => {
    window.scrollTo(0, 0);
    api.eventFetcher.getAll().then(() => {
      api.eventFetcher
        .getBySlug({ slug: this.props.match.params.slug })
        .then((r) => {
          if (!r.data.length) {
            console.log(
              "error fetching event page by slug: ",
              this.props.match.params.slug
            );
            return;
          } else {
            let page = r.data[0];
            this.props.setCurrentView(page);
            this.setState({ loading: false });
            this.getRelatedEvents();
          }
        });
    });
  };

  scrapeForImages() {
    let { page } = this.props;

    if (page.acf.modules) {
      let arr = [];

      let twoImagesArr = page.acf.modules.filter(
        (module) => module.acf_fc_layout === "two_images"
      );
      if (twoImagesArr.length) {
        twoImagesArr.map((module) => {
          arr.push({ image: module.image_one });
          arr.push({ image: module.image_two });
          return null;
        });
      }

      let imageModuleArr = page.acf.modules.filter(
        (module) => module.acf_fc_layout === "image"
      );
      if (imageModuleArr.length) {
        imageModuleArr.map((module) => {
          arr.push({ image: module.image });
          return null;
        });
      }

      this.props.setImageGallery(arr);
    }
  }

  getRelatedEvents() {
    const { page } = this.props;
    const checkDate = (a, b) => {
      if (a.acf.from_date > b.acf.from_date) {
        return 1;
      } else if (a.acf.from_date < b.acf.from_date) {
        return -1;
      } else {
        return 0;
      }
    };
    let related_events = [];
    let eventIndex;
    let sorted = this.props.events.sort((a, b) => checkDate(a, b));

    sorted.map((event) => {
      if (event.id === page.id) {
        eventIndex = sorted.indexOf(event);
      }
      return null;
    });

    let after = sorted.slice(eventIndex + 1);
    let before = sorted.slice(0, eventIndex);

    if (!after.length) {
      related_events.push(before[before.length - 1], before[before.length - 2]);
    } else if (!before.length) {
      related_events.push(after[0], after[1]);
    } else {
      related_events.push(before[before.length - 1], after[0]);
    }

    this.setState({ related_events: related_events }, () =>
      this.scrapeForImages()
    );
  }

  render() {
    const { isMobile, related_events, loading } = this.state;
    const { page } = this.props;

    if (!page || (page && loading)) return null;
    return (
      <Wrapper key={page.id}>
        <Container grid>
          <GridElement
            colStart={{ default: 1, s: 7 }}
            colEnd={{ default: 8, s: 18 }}
          >
            <h1>{page.acf.title}</h1>
            <p>{page.acf.description}</p>
          </GridElement>
        </Container>
        <EventInfo
          data={page}
          src={page.acf.src}
          phone={page.acf.phone}
          web_page_url={page.acf.web_page_url}
          isMobile={isMobile}
        />
        <Modules>
          <ErrorBoundary for='Dining Builder'>
            {page &&
              page.acf.modules &&
              page.acf.modules.map((module, i) => {
                return (
                  <div key={i} className={"module-" + module.acf_fc_layout}>
                    {React.createElement(modules[module.acf_fc_layout], {
                      data: module,
                    })}
                  </div>
                );
              })}
          </ErrorBoundary>
        </Modules>
        {page.acf.form && <RegistrationForm data={page} />}
        {related_events.length && <RelatedEvents links={related_events} />}
        <Overlay />
        <ErrorBoundary for='Footer'>
          <Footer />
        </ErrorBoundary>
        <CookieNotice />
      </Wrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  events: state.events.posts[WP.lang] ? state.events.posts[WP.lang] : [],
  page: state.currentView,
});

const actions = {
  setImageGallery,
  setCurrentView,
};

export default connect(mapStateToProps, actions)(withRouter(SingleEventPage));

const Wrapper = styled.section`
  scroll-behavior: smooth;
  width: 100%;
  padding-top: 120px;

  .container {
    h1 {
      ${theme.fonts.h2};
      margin-bottom: ${(props) => props.theme.spacing.contentXL};
    }
    p {
      ${theme.fonts.h5};
      margin-bottom: ${(props) => props.theme.spacing.contentL};
    }

    ${Media.greaterThan("s")`
            h1 {
                margin-bottom: ${(props) => props.theme.spacing.elementS};
            }
            p {
                margin-bottom: ${(props) => props.theme.spacing.elementS};
            }
        `}
  }

  ${Media.greaterThan("s")`
        padding-top: 220px;
    `}
`;

const Modules = styled.section`
  padding-bottom: ${(props) => props.theme.spacing.blockS};

  ${Media.greaterThan("s")`
        padding-bottom: ${(props) => props.theme.spacing.blockXL};
    `}
`;
